import React, { useState } from 'react';
import { ReptoolModal } from '../../utilities/ReptoolModal.tsx';
import { BasicFetch } from '../../../utils/BasicFetch.ts';
import { CollectionReptile } from '../../collection/types/CollectionTypes.ts';
import { Morph } from '../../../types/Morph.ts';
const SoldItem = ({
    reptile,
    morphs,
    updateReptiles,
    index
}: {
    reptile: CollectionReptile,
    morphs: Morph[],
    updateReptiles: (index: number, reptile: CollectionReptile) => void,
    index: number
}) => {
    let picture = reptile.picture || "images/notavailable.jpg";
    let credit = "";
    if (picture === "" || picture === "images/notavailable.jpg") {
        const morphInfo = morphs.find(morph => morph.name === reptile.morph_name);
        if (morphInfo && morphInfo.pictures && morphInfo.pictures[0]) {
            const morphPic = morphInfo.pictures[0];
            picture = morphPic.url;
            credit = morphPic.credit;
        }
    }
    return (
        <div className="row no-pad sold-acc">
            <div className="col-4">
                <img src={picture} className='w-100' alt={reptile.name || reptile.morph_name || 'Reptile'} />
                <h6 className="tile-photo-credit mt-2">{credit}</h6>
            </div>
            <div className="col-4">
                <h6>{reptile.name || reptile.morph_name}</h6>
            </div>
            <div className="col-4 d-flex flex-row">
                <div className="col-2 no-pad">
                    <h6>$</h6>
                </div>
                <div className="col-10 no-pad">
                    <input className="w-100" onChange={(event) => updateReptiles(index, { ...reptile, sold_price: parseFloat(event.target.value) || 0 })} type='number' />
                </div>
            </div>
        </div>
    )
}

export const SoldModal = ({
    reptiles,
    morphs,
    onMove,
    closeModal,
}: {
    reptiles: CollectionReptile[],
    morphs: Morph[],
    onMove: () => void,
    closeModal: () => void,
}) => {
    const [soldReptiles, setSoldReptiles] = useState(reptiles);
    const updateReptiles = (index: number, reptile: CollectionReptile) => {
        const newReptiles = [...soldReptiles];
        newReptiles[index] = reptile;
        setSoldReptiles(newReptiles);
    }
    const moveToSold = () => {
        const url = `${(window as any).serverLocation}collection_reptile/sold_reptiles`;

        BasicFetch({
            url,
            data: {
                soldReptiles,
            },
            method: 'POST',
            onSuccess: (data) => {
                window.alert("Successfully marked reptiles as sold.")
                onMove()
            },
            onFail: () => {
                window.alert("Failed to mark reptiles as sold please try again later.");
            }
        })
    }

    return (
        <ReptoolModal id="sold-dialog" title="Just Sold" closeModal={closeModal} body={(
            <React.Fragment>
                <div className="modal-content">
                    {soldReptiles.map((reptile, index) => <SoldItem key={index} reptile={reptile} morphs={morphs} index={index} updateReptiles={updateReptiles} />)}
                </div>
                <div className="modal-footer text-center">
                    <div id='move-button' className="button" onClick={moveToSold}>Move To Sold</div>
                </div>
            </React.Fragment>
        )} />
    )
}